﻿import { v1_3_request_booking_search_criteria_date_range} from "./v1_3_request_booking_search_criteria_date_range";

export class v1_3_request_booking_search_criteria {
    public first_name: string  | null = null;
    public second_name: string | null = null;
    public email: string | null = null;
    public your_reference: string | null = null;
    public all_booking_states: boolean = false;
    public is_agent_search: boolean = false;

    public booking_date: v1_3_request_booking_search_criteria_date_range = new v1_3_request_booking_search_criteria_date_range();
    public departure_date: v1_3_request_booking_search_criteria_date_range = new v1_3_request_booking_search_criteria_date_range();
    public expiry_date: v1_3_request_booking_search_criteria_date_range = new v1_3_request_booking_search_criteria_date_range();
}